import React from 'react';

const Logo = () => (
	<svg xmlns="http://www.w3.org/2000/svg" height={50} viewBox="0 0 470 162.2">
		<title>Tyger</title>
		<g>
			<path
				fill="#222222"
				id="e"
				d="M389,87.51c-.15-20-4.63-35.39-20.59-45-32-15.74-74.38-.36-73,40.63-.34,17.2,7.67,33.69,22.15,41C342,136.27,380.13,130,388.07,100l-31.83,0c-8.53,14.16-27.77,8.67-28.24-8h61ZM358.58,75H329c1-9.47,6.14-16.07,15.37-16.14,2.09,0,6.61.7,10.57,5.49C358.35,68.47,358.69,75,358.58,75Z"
			/>
			<path
				fill="#222222"
				id="t"
				d="M47,64V93.68c-1.15,14,9.86,9.5,18,4.87l0,27.38C5.38,139.83,12.26,110.46,12.14,64H0V38H12V15L47,0V38H75V64Z"
			/>
			<path
				fill="#222222"
				id="y"
				d="M188.78,38c-7.54,16-35.06,105.52-47.21,116-13,10.62-32.72,9.69-52.57,4.26V131.8c10.81,6.67,27.09,10.29,31.69-5.87L83.78,38H115c17.54,37.23,17,38.75,21.11,58.92,1.56,1.87,2.7-.32,2.6-2.56,3.64-23.27,19.17-57.23,18.8-56.36Z"
			/>
			<path
				fill="#222222"
				id="g"
				d="M285,121.08V38H257.7c.12,5.85-.17,10.32,3.09,16,2,3.5,4.17,7.89.5,6.49C239.92,21.59,194,33.13,187.48,78.39c-3.12,19.29,12,45.87,36.58,44.73,11.26.32,20.13-3.47,25.83-11-.08,6.42.92,20.25-3.39,23.92-6.09,6.42-23.65,4.69-22.85-7H189.84c-3.44,33.13,38.11,36.66,67.22,31C275.61,156.53,286.55,139.15,285,121.08ZM228.57,97.21c-26.73-5.64-7.07-39.35,13.85-33.81C266,70.61,247.55,100.69,228.57,97.21Z"
			/>
			<path
				fill="#222222"
				id="r"
				d="M470,41V71.32c-10.18-10.48-20.24-10.13-27.74-2.09-10.6,10.33-6.51,43.5-7.26,58.78H400V37h27.13c-.26,5.34.63,11.43-3.82,18.42-.7,1.15-1.82,3.36-1.82,4.34,1.22,5,8.26-8.45,9.77-9.85C440.81,34.29,454.89,32.71,470,41Z"
			/>
		</g>
	</svg>
);

export default Logo;
